import type { TrendingItem } from '@bulknutrients/bulk-shared-lib/interfaces/Menu';
import { BulkErrorBoundary } from '@components/Alerts/ErrorBoundaryFallback';

import { CustomImage } from '@components/Media/Image';

export const MenuTrending = ({ items }: { items: TrendingItem[] | null }) => {
  return (
    <BulkErrorBoundary location="MenuTrending">
      <h3 className="text-grey-dark dark:text-white mt-4">
        <strong>What's trending</strong>
      </h3>
      <div className="my-4 grid grid-cols-2 gap-4">
        {items?.map((item, index) => (
          <CustomImage
            image={item}
            width={240}
            height={240}
            key={index}
            templateOverride={{ crop: 'auto' }}
            className="gae-trending-item"
          />
        ))}
      </div>
    </BulkErrorBoundary>
  );
};
